import React from 'react';
import { Typography, Box } from '@mui/material';

interface DealSenderStatusMessageProps {
  sender: string | undefined;
  isClosed?: boolean;
  closedReason?: string | null;
  resentToDealId?: number | null;
}

const DealSenderStatusMessage: React.FC<DealSenderStatusMessageProps> = ({
  sender,
  isClosed = false,
  closedReason,
  resentToDealId,
}) => {
  // Show closed status if the deal is closed (manual resend)
  if (isClosed && closedReason === 'manual_resend') {
    return (
      <Box sx={{ marginTop: 1, textAlign: 'center' }}>
        <Typography
          sx={{
            fontSize: 16,
            color: '#ff9800',
            fontWeight: 600,
          }}
          align="center"
          variant="body2"
          className="MuiTypographyTable"
        >
          🔄 Cotation renvoyée
        </Typography>
        {resentToDealId && (
          <Typography
            sx={{
              fontSize: 12,
              color: '#9e9e9e',
              marginTop: 0.5,
            }}
            align="center"
            variant="caption"
          >
            Nouveau deal: #{resentToDealId}
          </Typography>
        )}
      </Box>
    );
  }

  if (sender === 'agency') {
    return (
      <Typography sx={{ marginTop: 1, fontSize: 16 }} align="center" variant="body2" className="MuiTypographyTable">
        ❌ Cotation clôturée
      </Typography>
    );
  } else if (sender === 'evo') {
    return (
      <Typography sx={{ marginTop: 1, fontSize: 16 }} align="center" variant="body2" className="MuiTypographyTable">
        🕒 En attente d'informations
      </Typography>
    );
  }
  return null;
};

export default DealSenderStatusMessage;
